module.exports = __webpack_public_path__ + "img/vehicle-mutation-confirm.ebf9aa93.svg";